import { memo, useState } from 'react'
import UnifiedAuthForm from './UnifiedAuthForm'

/**
 * AuthForm - Authentication form with internal mode state
 *
 * Renders login or register form based on internal mode, driven by
 * UnifiedAuthForm's onSwitchMode callback. No longer depends on activeTab.
 *
 * @idempotent - Pure form component with external state
 * @atomic - Single responsibility: auth form with mode switching
 */
const AuthForm = memo(function AuthForm({
  loginFormData,
  loginErrors,
  handleLoginChange,
  handleLoginSubmit,
  registerFormData,
  registerErrors,
  handleRegisterChange,
  handleRegisterSubmit,
  isAuthLoading,
  googleAuth
}) {
  const [mode, setMode] = useState('login')
  const isLogin = mode === 'login'

  return (
    <UnifiedAuthForm
      mode={mode}
      formData={isLogin ? loginFormData : registerFormData}
      errors={isLogin ? loginErrors : registerErrors}
      onChange={isLogin ? handleLoginChange : handleRegisterChange}
      onSubmit={isLogin ? handleLoginSubmit : handleRegisterSubmit}
      isLoading={isAuthLoading}
      onGoogleAuth={googleAuth}
      onSwitchMode={setMode}
      showHeader={true}
      immersiveMode={true}
    />
  )
})

export default AuthForm
